/**
 * Registers the collection settings at `/collection`, order 35, beside the
 * operation prices.
 */

import { createElement } from 'react';
import { Activity } from 'lucide-react';

import type { OpsRouteBundle } from '../routes/contract';
import { OpsShell } from '../shell/OpsShell';
import { Collection } from './Collection';
import { t } from './messages';

export const bundle: OpsRouteBundle = {
  order: 35,
  routes: [
    {
      path: '/collection',
      element: createElement(OpsShell, null, createElement(Collection)),
      kind: 'data',
    },
  ],
  nav: [{ path: '/collection', label: () => t('nav.label'), icon: Activity, kind: 'data' }],
};
